/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { MultipleResponseAnswersIrideGetDto } from '../../models/multiple-response-answers-iride-get-dto';

export interface ApiWsBridgeAlertcallIdAnswersGet$Params {
    /**
     * Alert call ID or irideAlertId
     */
    request: string;
}

export function apiWsBridgeAlertcallIdAnswersGet(
    http: HttpClient,
    rootUrl: string,
    params: ApiWsBridgeAlertcallIdAnswersGet$Params,
    context?: HttpContext,
): Observable<StrictHttpResponse<MultipleResponseAnswersIrideGetDto>> {
    const rb = new RequestBuilder(rootUrl, apiWsBridgeAlertcallIdAnswersGet.PATH, 'get');
    if (params) {
        rb.query('request', params.request, {});
    }

    return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
        filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
        map((r: HttpResponse<any>) => {
            return r as StrictHttpResponse<MultipleResponseAnswersIrideGetDto>;
        }),
    );
}

apiWsBridgeAlertcallIdAnswersGet.PATH = '/api/ws-bridge/alertcall/:id/answers';
